import React from 'react';
import bgImage from '../../assets/images/backgrounds/background_culture.png';
import TextContentHeader from './TextContentHeader';
import TextContentInner from './TextContentInner';
import { CultureContentData } from '../../Data/CultureContent';

function CultureContent() {
  return (
    <div className="text-content">
      <div
        className="text-content-wrapper position-relative bg-black"
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <TextContentHeader heading="Our people embrace experience." />
        <TextContentInner content={CultureContentData} />
      </div>
    </div>
  );
}

export default CultureContent;